<template>
  <div v-if="music.km_mid" class="single">
    <van-sticky>
      <van-nav-bar
        left-arrow
        :border="false"
        @click-left="onClickLeft"
      ><template #left>
        <span class="iconfont icon-houtui fs-24 fw-700"></span>
        </template>
        <template v-if="music.status === 99 && music.sp_share === 1" #right>
          <span class="iconfont icon-share1 fs-24 fw-700" @click="share"></span>
        </template>
      </van-nav-bar>
    </van-sticky>
    <div class="flex justify-center img-wrapper">
      <img :src="music.picsrc" class="img" alt="">
      <img src="http://sanka-static.oss-cn-beijing.aliyuncs.com/h5/bg/bg-album.png" class="bg-img">
    </div>
    <div class="info-wrapper">
      <div class="info">
        <div class="fs-18 color-0D0E15 mt-15 text-center fw-700">{{ music.music_name }}</div>
        <p class="text-center mt-6">创建时间：{{ music.createtime * 1000 | formatTime }}</p>
        <div class="fs-12 mt-6">
          <p class="van-ellipsis">表演者：{{ music.singer && music.singer.replace(/\+/g, ',') }}</p>
          <p v-if="music.pure_music === 1" class="van-ellipsis mt-4">作词者：<van-tag color="pink" round>纯音乐</van-tag></p>
          <p v-else class="van-ellipsis mt-4">作词者：{{ music.writer && music.writer.replace(/\+/g, ',') }}</p>
          <p class="van-ellipsis mt-4">作曲者：{{ music.composer && music.composer.replace(/\+/g, ',') }}</p>
        </div>
        <div class="status mt-6">
          <van-tag :color="tagTypes[music.status]" round style="padding: 3px 5px;">{{ musicStatus[music.status + String(music.sp_online)] }}</van-tag>
        </div>
      </div>
      <mr-source :source-list="sourceList" :issue-area="music.issue_area"></mr-source>
      <div class="materials-wrapper">
        <div class="flex align-center">
          <span class="mr-8">物料完整度</span>
          <van-progress
            :percentage="progressMusic"
            track-color="#F3F4F6"
            :show-pivot="false"
            stroke-width="6px"
            color="linear-gradient(270deg, #0DC268 0%, #4CD964 100%)"
            class="flex-1 mr-8"
          />
          <span>完整度{{ progressMusic }}%</span>
        </div>
        <div class="flex align-center justify-between mt-28">
          <mr-material v-for="item in materialList" :material="item" :key="item.iconClass" class="fs-12"></mr-material>
        </div>
      </div>
    </div>
    <mr-share ref="MrShare" :music="music"></mr-share>
  </div>
</template>

<script>
import MrMaterial from '../components/material-item'
import MrSource from '../components/source'
import { getMusicInfo } from '@/api/music.js'
import { mapState } from 'vuex'
export default {
  name: 'SingleMusic',
  components: { MrMaterial, MrSource },
  data() {
    return {
      music: {}
    }
  },
  computed: {
    materialList() {
      const { media_count } = this.music
      const list = Object.entries(media_count).filter(val => val[1] > 0).map(val => val[0])
      return this.mediaArr.map(val => ({
        ...val,
        active: list.includes(val.key) ? 1 : 0
      }))
    },
    sourceList() {
      const { issue_area } = this.music
      return this.areas.map(val => ({
        ...val,
        active: this.issueArea[issue_area].includes(val.key)
      }))
    },
    progressMusic() { // 作品物料百分比
      const totalCount = this.mediaArr.length // 物料总个数
      const count = this.materialList.filter(val => val.active > 0).length // 物料点亮的个数
      return count === 0 ? 0 : Math.round((100 / totalCount) * count)
    },
    ...mapState(['musicStatus', 'tagTypes', 'mediaArr', 'areas', 'issueArea'])
  },
  async created() {
    this.$store.commit('TOGGLE_LOADING', true)
    try {
      await this.getMusicInfo()
    } finally {
      this.$store.commit('TOGGLE_LOADING', false)
    }
  },
  methods: {
    async getMusicInfo() {
      const res = await getMusicInfo({ km_mid: this.$route.query.id })
      this.music = res.data
    },
    onClickLeft() {
      this.$router.back()
    },
    share() {
      this.$refs.MrShare.share({ ...this.music, album_type: 'single' })
    }
  }
}
</script>

<style lang="scss" scoped>
.single{
  padding-bottom: 20px;
}
.img-wrapper{
  height: 240px;
  padding: 0 36px;
  .img{
    width: 240px;
    height: 100%;
  }
  .bg-img{
    width: 23px;
    height: 100%;
  }
}
.info{
  padding: 0 16px;
}
.source{
  margin-top: 15px;
}
.materials-wrapper{
  padding: 16px;
}
.icon-share1{
  color: rgb(107, 106, 106);
}
</style>
